import { render, staticRenderFns } from "./VouchersComponent.vue?vue&type=template&id=561411f9&scoped=true"
import script from "./VouchersComponent.vue?vue&type=script&lang=js"
export * from "./VouchersComponent.vue?vue&type=script&lang=js"
import style0 from "./VouchersComponent.vue?vue&type=style&index=0&id=561411f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561411f9",
  null
  
)

export default component.exports